import axios from "axios";

export const apiPayment = axios.create({
  baseURL:
    process.env.REACT_APP_MS_PAYMENT_URL ||
    "http://localhost:4000",
  headers: {
    "x-api-provider": "pro-xp",
  },
});
